const events = {
    init() {

        document.querySelectorAll('._bl_choices[data-group]').forEach((wrap) => {
            const group = wrap.getAttribute('data-group');
            const input = document.querySelector(`input[data-group="${group}"]`);
            if (!input) return;

            wrap.addEventListener('click', (e) => {
                const choice = e.target.closest('._choice');
                if (!choice) return;

                choice.classList.toggle('_selected');

                const values = Array.from(wrap.querySelectorAll('._choice._selected'))
                    .map(el => el.dataset.id);

                // JSON propre dans le input
                input.value = JSON.stringify(values);

                input.dispatchEvent(new Event('change', { bubbles: true }));
            });
        });



        // 2) Hydratation initiale : si un input a déjà une valeur, refléter la sélection
        // document.querySelectorAll('input[data-group]').forEach((input) => {
        //     const group = input.getAttribute('data-group');
        //     const val = input.value?.trim();
        //     if (!val) return;
        //
        //     const wrap = document.querySelector(`._bl_choices[data-group="${group}"]`);
        //     if (!wrap) return;
        //
        //     // on cherche d'abord par data-id, sinon par texte
        //     let choice = wrap.querySelector(`._choice[data-id="${CSS?.escape ? CSS.escape(val) : val}"]`);
        //     if (!choice) {
        //         choice = Array.from(wrap.querySelectorAll('._choice'))
        //             .find(c => c.textContent.trim() === val);
        //     }
        //     if (choice) {
        //         wrap.querySelectorAll('._choice._selected').forEach(el => el.classList.remove('_selected'));
        //         choice.classList.add('_selected');
        //     }
        // });
    },
};

export default events;
